import React, { useEffect, useState } from "react";
import { useApp } from "../context/AppContext";
import { fetchLookbook, fetchSiteContent } from "../lib/api";
import { Marquee } from "../components/Marquee";

const FALLBACK = [
  "https://images.unsplash.com/photo-1738636591778-b4e73eb2748f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwxfHxzdHJlZXR3ZWFyJTIwaGVhdnklMjBtZXRhbCUyMGJsYWNrJTIwc2hpcnQlMjBmYXNoaW9ufGVufDB8fHx8MTc3ODI4NTE5OXww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1754472390008-e1ddbed633ea?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwzfHxzdHJlZXR3ZWFyJTIwaGVhdnklMjBibGFjayUyMHNoaXJ0JTIwZmFzaGlvbnxlbnwwfHx8fDE3NzgyODUxOTl8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1609269879435-6d188776e3aa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwzfHx3cmVzdGxpbmclMjBtYXNrJTIwbHVjaGElMjBsaWJyZXxlbnwwfHx8fDE3NzgyODUxNzh8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1748302913353-90a60a1cba9b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwzfHxwdW5rJTIwcm9jayUyMG11c2ljJTIwY3Jvd2QlMjBkYXJrfGVufDB8fHx8MTc3ODI4NTE3OHww&ixlib=rb-4.1.0&q=85",
  "https://images.pexels.com/photos/35029664/pexels-photo-35029664.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.unsplash.com/photo-1675784173767-a38ffd54a68e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwyfHxwdW5rJTIwcm9jayUyMG11c2ljJTIwY3Jvd2QlMjBkYXJrfGVufDB8fHx8MTc3ODI4NTE3OHww&ixlib=rb-4.1.0&q=85",
];

const resolveUrl = (u) => {
  if (!u) return u;
  if (u.startsWith("http")) return u;
  if (u.startsWith("/api/")) return `${process.env.REACT_APP_BACKEND_URL}${u}`;
  return u;
};

export default function Lookbook() {
  const { lang } = useApp();
  const [items, setItems] = useState([]);
  const [site, setSite] = useState({});

  useEffect(() => {
    fetchLookbook()
      .then((d) => setItems(d.length ? d : FALLBACK.map((u, i) => ({ id: `fb-${i}`, url: u, order: i }))))
      .catch(() => setItems(FALLBACK.map((u, i) => ({ id: `fb-${i}`, url: u, order: i }))));
    fetchSiteContent().then(setSite).catch(() => {});
  }, []);

  const title = (lang === "pt" ? site.lookbook_title_pt : site.lookbook_title_en) || "CAPSULE 02.";
  const sub =
    (lang === "pt" ? site.lookbook_sub_pt : site.lookbook_sub_en) ||
    "IN THE RING — shot in Porto and Lisboa, December 2025.";

  return (
    <div data-testid="page-lookbook">
      <section className="max-w-[1600px] mx-auto px-5 md:px-10 pt-12 md:pt-20 pb-10">
        <p className="font-mono text-xs tracking-[0.3em] text-kult-yellow">/ LOOKBOOK</p>
        <h1 className="font-display text-6xl md:text-9xl mt-2 leading-none">{title}</h1>
        <p className="text-kult-muted max-w-xl mt-3">{sub}</p>
      </section>

      <Marquee items={["IN THE RING", "PORTO", "LISBOA", "ANALOG SHOT"]} bg="bg-kult-yellow" />

      <section className="max-w-[1600px] mx-auto px-5 md:px-10 py-12 grid grid-cols-12 gap-3 md:gap-5">
        {items.map((it, i) => {
          const span =
            i === 0
              ? "col-span-12 md:col-span-7"
              : i === 4
              ? "col-span-12"
              : i % 3 === 1
              ? "col-span-6 md:col-span-5"
              : i % 3 === 2
              ? "col-span-6 md:col-span-4"
              : "col-span-12 md:col-span-8";
          const aspect = i === 4 ? "aspect-[21/9]" : i === 0 ? "aspect-[4/5]" : "aspect-[4/5]";
          return (
            <img
              key={it.id || i}
              src={resolveUrl(it.url)}
              alt={(lang === "pt" ? it.caption_pt : it.caption) || ""}
              className={`${span} ${aspect} object-cover border border-kult-border`}
            />
          );
        })}
      </section>
    </div>
  );
}
